<template>
  <div>
    <!-- //FILTRO -->
    <div class="row" v-if="!list">
      <div
        class="col-md-12 text-right"
        style="flex-wrap: wrap; margin-bottom: 10px"
      >
        <btn-rounded
          class="text-right"
          :label="filter ? 'LIMPAR' : 'FILTRO'"
          event="showFilter"
          :active-color="filter ? 'danger' : 'primary'"
        />
      </div>

      <div v-if="filter">
        <div class="row" style="padding: 5px" text-center>
          <div class="col-md-3">
            <fg-select
              :options="materialList"
              v-model="filterOptions.MaterialId"
              :selected="filterOptions.MaterialId"
              label="Tipo de Material"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Inicial"
              :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart"
            />
          </div>

          <div class="col-md-3">
            <fg-input
              type="date"
              label="Data de criação Final"
              :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd"
            />
          </div>
        </div>

        <div class="row" style="padding: 5px" text-center>
          <div class="col-md-6">
            <fg-input
              type="text"
              label="Código, nome e descrição."
              placeholder="Código, nome e descrição..."
              v-model="filterOptions.term"
            />
          </div>
        </div>

        <div class="row" style="margin-bottom: 10px">
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded
                class="text-right"
                label="FILTRAR"
                event="activeFilter"
                active-color="success"
              />
            </div>
          </div>
        </div>
      </div>

    
    </div>
    <!-- FILTRO// -->

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table
            eventName="selectItem"
            :title="table.title"
            :sub-title="table.subTitle"
            :data="list || carPendinglist"
            :columns="table.columns"
            :headers="table.headers"
            :buttonsConfirm="table.buttons"
          />
        </div>
      </div>
    </div>

    <v-dialog />

    <modal name="approveModal" :adaptive="true" height="auto" width="500">
      <div style="padding: 30px">
        <h4 class="title" style="margin-top: 0; font-weight: 600;">Aprovar Anúncio</h4>
        <p class="category" style="color: #666;">Defina as configurações de prioridade para este anúncio:</p>
        <hr style="margin: 20px 0; border-top: 1px solid #eee;" />
        
        <div class="row">
          <div class="col-md-12">
            <fg-checkbox 
              label="Utilizar Lista VIP para este anúncio" 
              v-model="approvalOptions.useVipList" 
              style="margin-bottom: 5px"
            />
          </div>
        </div>

        <div class="row" v-if="approvalOptions.useVipList" style="margin-top: 15px">
          <div class="col-md-12">
            <fg-input
              type="number"
              label="Horas de Prioridade (Exclusividade VIP)"
              v-model="approvalOptions.vipPriorityHours"
              placeholder="Padrão: 24 horas"
              style="margin-bottom: 0"
            />
            <div style="margin-top: 5px; display: flex; align-items: center; background: #f9f9f9; padding: 8px 12px; border-radius: 6px; border-left: 3px solid #41b883;">
              <i class="ti-info-alt" style="color: #41b883; margin-right: 10px; font-size: 14px;"></i>
              <small style="color: #666; font-size: 12px; line-height: 1.2;">
                Compradores VIP terão acesso exclusivo a este anúncio durante o período definido.
              </small>
            </div>
          </div>
        </div>

        <div class="text-right" style="margin-top: 40px">
          <btn-rounded 
            label="CANCELAR" 
            @click.native="$modal.hide('approveModal')" 
            active-color="danger" 
            style="margin-right: 12px; padding: 10px 25px;"
          />
          <btn-rounded 
            label="CONFIRMAR E PUBLICAR" 
            @click.native="confirmApproval" 
            active-color="success" 
            style="padding: 10px 25px;"
          />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
import { mapActions, mapState, mapGetters } from "vuex";

import moment from "moment";
const headers = [
  "/",
  "Código",
  "Usuário",
  "Contato",
  "E-mail",
  "Veículo",
  "Placa",
  "Km",
  "Descrição",
  "Valor",
  "Data Cadastrado",
  "Status",
  "Aprovar",
];
const tableColumns = [
  {
    columnName: "CarImages",
    logic: function(data, columnData) {
      var find = true;
      if (!data) {
        find = false;
      } else if (!data.length) {
        find = false;
      } else if (!data.length > 0) {
        find = false;
      }

      if (find) {
        return (
          '<img src="' +
          data[0].imageThumbURL +
          '" style="width:36px; height: 36px; border-radius: 50%; border: 2px solid black" v-viewer >'
        );
      } else {
        return '<img src="https://api.carrocash.com.br/image/render/thumb/default.png" style="width:36px; height: 36px; border-radius: 50%; border: 2px solid black" v-viewer >';
      }
    },
  },
  "code",
  "User.name",
  "User.formattedPhone",
  "User.email",
  "name",
  "plate",
  "mileage",
  "description",
  "formattedValueCentavos",
  {
    columnName: "createdAt",
    logic: function(data, columnData) {
      if (!data) {
        return "";
      }
      return moment
        .utc(data)
        .utcOffset(0)
        .format("D/M/YYYY H:mm:ss");
    },
  },
  {
    columnName: "isApproved",
    logic: function(data) {
      let className = "text-danger";
      let val = "Aguardando";
      if (data) {
        className = "text-success";
        val = "Aprovado";
      }
      let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

      return `${prefix} ${val}`;
    },
  },
];
const buttons = [
  {
    event: "approveCar",
    icon: "/static/img/confirm.png",
    class: "",
    tooltip: "Aprovar Carro",
  },
  {
    event: "rejectCar",
    icon: "/static/img/cancel.png",
    class: "",
    tooltip: "Recusar Carro",
  },
];

export default {
  components: {
    ComponentTable,
  },

  props: {
    list: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },

  computed: {
    ...mapState({
      carPendinglist: ({ car }) => car.toValidateList,

      materialList: ({ material }) =>
        material.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id,
          };
        }),
    }),
    ...mapGetters({
      sidebarFlag: "sidebarFlag",
    }),
  },

  watch: {
    $route: "initData",
  },
  methods: {
    ...mapActions([
      "getCarToValidateList",
      "approveCar",
      "reproveCar",
      "getMaterialList",
    ]),

    

    openCarousel(image, CarId) {
      this.CarImages = image;
      this.image = true;
      this.currentCarId = CarId;
      this.$modal.show("openImages");
    },
    closeCarousel() {
      this.$modal.hide("openImages");
      this.current = 0;
    },
    // closeCarousel() {
    //   this.image = false;
    //   this.current = 0;
    // },
    selectSlide(index) {
      this.current = index;
      // Outras lógicas necessárias ao selecionar um slide
    },

    setPage: function(page) {
      this.page = page;
    },

    cleanFilter() {
      for (let idx in this.filterOptions) {
        this.filterOptions[idx] = undefined;
      }
      // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
      // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
      this.initData();
    },

    initData() {
      if (this.$route.params) {
        this.filterOptions.isAdmin = this.$route.params.isAdmin;
      }

      if (!this.list) {
        return this.getCarToValidateList(this.filterOptions).then((res) => {});
      }

      return Promise.resolve({});
    },

    confirmApproval() {
      const item = this.selectedCarForApproval;
      if (!item) return;

      this.approveCar({
        CarId: item.id,
        isApproved: true,
        useVipList: this.approvalOptions.useVipList,
        vipPriorityHours: this.approvalOptions.vipPriorityHours
      })
      .then((res) => {
        this.$notify({
          group: "foo",
          title: "Sucesso",
          text: "Anúncio aprovado e leilão criado!",
          position: "top center",
          type: "success",
        });
        this.$modal.hide("approveModal");
        this.initData();
      })
      .catch((res) => {
        this.$notify({
          group: "foo",
          title: "Erro ao aprovar",
          text: res.msg || res.info || "Não foi possível aprovar o anúncio",
          position: "top center",
          type: "error",
        });
      });
    }
  },

  created() {
    this.cleanFilter();
    this.$on("novo", () => {
      this.$router.push("/admin/usuarios/criar");
    });

    // this.$on("openImageModal", (item) => {
    //   console.log(item);
    //   this.image = true;
    //   this.CarImages = item;
    // }),
    this.$on("selectItem", (item, tableColumns) => {
      console.log(item);
      if (typeof tableColumns === "object") {
        this.image = true;
        if (this.CarImages.length > 0) {
          this.CarImages = [];
          this.current = 0;
          this.openCarousel(item.CarImages, item.id);
        } else {
          this.openCarousel(item.CarImages, item.id);
        }
        // this.selectSlide(this.current);
      } else {
        this.$modal.show("dialog", {
          title: "Direcionamento",
          text: "Deseja realmente entrar na alteração desse carro?",
          buttons: [
            {
              title: "Sim",
              handler: () => {
                this.$router.push({
                  name: "Auditáveis - Editar",
                  params: { id: item },
                });

                this.$modal.hide("dialog");
              },
            },
            {
              title: "Não", // Button title
              handler: () => {
                this.$modal.hide("dialog");
              }, // Button click handler
            },
          ],
        });
      }
    });
    this.$on("showFilter", () => {
      if (this.filter) this.cleanFilter();
      this.filter = !this.filter;
    });
    this.$on("activeFilter", () => {
      if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
        return this.$notify({
          group: "foo",
          title: "Busca invalida",
          text: "Minímo de 3 caracteres",
          position: "top center",
          type: "error",
        });
      }
      this.initData();
      // this.filter = !this.filter;
    });

    this.$on("approveCar", (item) => {
      this.selectedCarForApproval = item;
      this.approvalOptions.useVipList = false;
      this.approvalOptions.vipPriorityHours = 24;
      this.$modal.show("approveModal");
    });

    this.$on("rejectCar", (item) => {
      this.$modal.show("dialog", {
        title: "Atualizar status do Carro",
        text: "Deseja realmente desativar o cadastro deste carro?",
        buttons: [
          {
            title: "Sim",
            handler: () => {
              item.isApproved = false;

              this.reproveCar({ CarId: item.id, isApproved: item.isApproved })
                .then((res) => {
                  console.log(res);
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: "Status do carro alterado com sucesso",
                    position: "top center",
                    type: "success",
                  });
                  this.initData();
                })
                .catch((res) => {});

              this.$modal.hide("dialog");
            },
          },
          {
            title: "Não", // Button title
            handler: () => {
              this.$modal.hide("dialog");
            }, // Button click handler
          },
        ],
      });
    });
  },

  data() {
    return {
      page: 1,
      canvas: null,
      CarImages: [],
      image: false,
      current: 0,
      currentCarId: "",
      table: {
        title: "Anúncios",
        subTitle: "Lista de Veículos Aguardando Auditoria",
        headers: [...headers],
        columns: [...tableColumns],
        buttons: [...buttons],
      },
      filter: false,
      filterOptions: {
        isAdmin: undefined,
        isActive: undefined,
        term: undefined,
        intervalStart: undefined,
        intervalEnd: undefined,
      },
      selectedCarForApproval: null,
      approvalOptions: {
        useVipList: false,
        vipPriorityHours: 24
      },
      adminList: [
        {
          value: true,
          name: "Admin",
        },
        {
          value: false,
          name: "não Admin",
        },
      ],
      activeList: [
        {
          value: true,
          name: "Ativo",
        },
        {
          value: false,
          name: "Não Ativo",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>



canvas {
  border: 1px solid black;
}




</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mining/miningList.vue